export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/auth/login-ico-sns-line-32-65559b0f2b1e347d8e268ca1e6403cfb.svg";